import { render, staticRenderFns } from "./OrderPartialDetailsShipping.vue?vue&type=template&id=0d25a45a&"
import script from "./OrderPartialDetailsShipping.vue?vue&type=script&lang=js&"
export * from "./OrderPartialDetailsShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports